__turbopack_context__.v({
  "navButton": "searchPagination-module-scss-module__cxdlYa__navButton",
  "navIcon": "searchPagination-module-scss-module__cxdlYa__navIcon",
});
